import { useState } from 'react';
import { createContainer } from 'unstated-next';
import { LOCAL_STORAGE_TYPES } from '../constants';
import useLocalStorage from '../hooks/localstorage';

const initialState = {
  isClientsPopulated: false,
  clients: [],
  selectedClient: null,
  isLoading: true,
  isLoaded: false,
  isUpdated: false,
};

export function useClientHook(stateParam) {
  const [isWorkspaceDeleteModal, setIsWorkspaceDeleteModal] = useState(false);

  const { set } = useLocalStorage();
  const combinedState = {
    ...initialState,
    ...stateParam,
  };

  const [state, setState] = useState(combinedState);

  const updateClients = clients => {
    setState(prev => ({
      ...prev,
      clients,
      isClientsPopulated: true,
    }));
  };

  const resetClientState = () => {
    setState(initialState);
  };

  const updateSelectedClient = (clientId, clients) => {
    if (!Number.isNaN(Number(clientId))) {
      set(LOCAL_STORAGE_TYPES.WORKSPACE, { client: clientId });
    }
    const found = (clients ?? state.clients).find(
      client => client.id === clientId
    );
    if (found) {
      setState(prev => {
        return {
          ...prev,
          selectedClient: (clients ?? state.clients).find(
            client => client.id === clientId
          ),
        };
      });
    }
  };
  // this will manage a short term loading state when user change the selected client
  const updatingSelectedClient = () => {
    setState(prev => ({ ...prev, isUpdated: true }));
    setTimeout(() => {
      setState(prev => ({ ...prev, isUpdated: false }));
    }, 1000);
  };

  const updateNewSelectedClient = selectedClient => {
    set(LOCAL_STORAGE_TYPES.WORKSPACE, { client: selectedClient.id });
    setState(prev => {
      return {
        ...prev,
        selectedClient,
      };
    });
  };

  const updateClientAccounts = toUpdateAccount => {
    if (state.selectedClient) {
      if (Array.isArray(toUpdateAccount)) {
        const toUpdateAccArray = toUpdateAccount.map(acc => {
          return {
            ...acc,
            service: acc.provider?.type,
          };
        });

        const updateClientArray = state.clients.map(client => {
          if (client.id === state.selectedClient.id) {
            return {
              ...client,
              accounts: toUpdateAccArray,
            };
          }
          return client;
        });
        setState(prev => {
          return {
            ...prev,
            clients: [...updateClientArray],
            selectedClient: {
              ...(state.selectedClient ?? {}),
              accounts: toUpdateAccArray,
            },
          };
        });
        return;
      }
      const accountToBeUpdated = {
        ...toUpdateAccount,
        service: toUpdateAccount?.provider?.type,
      };
      const isAccountAlreadyExist = state.selectedClient.accounts.some(
        acc => acc.id === toUpdateAccount.id
      );

      if (isAccountAlreadyExist && state.selectedClient.account) {
        const accountIdx = state.selectedClient.account.findIndex(
          acc => acc.id === toUpdateAccount.id
        );
        const prevAccount = state.selectedClient.accounts.slice(0);
        prevAccount.splice(accountIdx, 1);
        const updateClientArray = state.clients.map(client => {
          if (client.id === state.selectedClient.id) {
            return {
              ...client,
              accounts: prevAccount,
            };
          }
          return client;
        });
        setState(prev => {
          return {
            ...prev,
            clients: updateClientArray,
            selectedClient: {
              ...state.selectedClient,
              accounts: prevAccount,
            },
          };
        });
      } else if (state.selectedClient.account) {
        const updatedAccounts = [
          ...state.selectedClient.accounts,
          accountToBeUpdated,
        ];
        const updateClientArray = state.clients.map(client => {
          if (client.id === state.selectedClient.id) {
            return {
              ...client,
              accounts: updatedAccounts,
            };
          }
          return client;
        });
        setState(prev => ({
          ...prev,
          clients: updateClientArray,
          selectedClient: {
            ...state.selectedClient,
            accounts: updatedAccounts,
          },
        }));
      }
    }
  };

  const updateClientIsLoading = isLoading => {
    setState(prev => ({
      ...prev,
      isLoading,
    }));
  };

  const updateClientIsLoaded = isLoaded => {
    setState(prev => ({
      ...prev,
      isLoaded,
    }));
  };

  return {
    state,
    updateClients,
    resetClientState,
    updateSelectedClient,
    updateClientAccounts,
    updateClientIsLoading,
    updateNewSelectedClient,
    isWorkspaceDeleteModal,
    setIsWorkspaceDeleteModal,
    updateClientIsLoaded,
    updatingSelectedClient,
  };
}

const ClientContainer = createContainer(useClientHook);

export default ClientContainer;
